import React from "react";
import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const GenericModal = ({ open, onClose, footer, title, children }) => {
  return (
    <Modal
      title={
        <div className="flex justify-between items-center">
          <span className="font-gilroyBold">{title}</span>
          <CloseOutlined onClick={onClose} className="cursor-pointer" />
        </div>
      }
      open={open}
      onCancel={onClose}
      footer={footer}
      centered
      maskClosable={true}
      className="how-it-works"
      closeIcon={null}
    >
      {children}
    </Modal>
  );
};

export default GenericModal;
